import * as z from "zod";

const sortingHourSchema = z.object({
  hour: z.number().int().min(0).max(23),
  sortedCount: z.number(),
});

export const getInboundDashboardSortingVolume = {
  name: "getInboundDashboardSortingVolume" as const,
  input: z.object({ teamIds: z.array(z.string()).optional() }),
  output: z.object({
    /** Warehouse-local day, `YYYY-MM-DD`. */
    date: z.string(),
    /** Midnight through the current hour. */
    hours: z.array(sortingHourSchema),
    generatedAt: z.string(),
  }),
};

export type GetInboundDashboardSortingVolumeOutput = z.infer<
  (typeof getInboundDashboardSortingVolume)["output"]
>;
